/**
 * The message to show for a failed call. A repository's `DomainError` carries
 * the contract's `detail` as its message; anything else falls back to its own.
 */
export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof Error && err.message) return err.message;
  return fallback;
}
